import { AppHeader } from "@/components/app-header";
import { AppFooter } from "@/components/app-footer";
import { useTranslation } from "@/common/providers/i18n-provider";
import { PricingSection } from "@/components/pricing/PricingSection";
import "@/styles/pricing.css";

export function PricingPage() {
  const { t } = useTranslation();
  return (
    <div className="pricing-page">
      <AppHeader />
      <main id="main">
        <header className="pricing-hero pricing-container">
          <h1>{t("pricing.hero.title")}</h1>
          <p>{t("pricing.hero.subtitle")}</p>
        </header>
        <PricingSection />
      </main>
      <AppFooter />
    </div>
  );
}
